import React from "react"
import StatCard from "./components/common/StatCard";
import PreBoardingNotificationsTable from "./components/tables/PreBoardingNotificationsTable";
import AuthManager from "../utils/AuthManager";

export default class PreBoardingNotifications extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
    }
  }

  componentDidMount() {

  }

  render() {
    let {
    } = this.state

    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <PreBoardingNotificationsTable
              title={"Pre Boarding Notifications"}
            />
          </div>
        </div>
      </>
    )
  }

}
